import { Link } from 'react-router-dom'
import { useAuthContext } from '../../hooks/useAuthContext'
import { Button } from '../ui/Button'

interface HeaderProps {
  variant?: 'overlay' | 'light'
}

export function Header({ variant = 'overlay' }: HeaderProps) {
  const { authenticated, clearAuth } = useAuthContext()

  const isOverlay = variant === 'overlay'
  const linkClasses = isOverlay
    ? 'text-2xl font-bold text-white drop-shadow-md hover:text-white/80 transition-colors'
    : 'text-2xl font-bold text-[var(--color-text-primary)] hover:text-[var(--color-text-secondary)] transition-colors'
  const buttonClasses = isOverlay
    ? 'text-white/80 border-white/30 hover:text-white hover:border-white/60 backdrop-blur-sm'
    : 'text-[var(--color-text-secondary)] border-[var(--color-border)] hover:text-[var(--color-text-primary)] hover:border-[var(--color-text-primary)]'

  return (
    <header className="w-full">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <Link to="/" className={linkClasses}>
          Shoots
        </Link>

        {authenticated && (
          <Button
            onClick={clearAuth}
            variant="outline"
            size="sm"
            className={buttonClasses}
          >
            <svg
              className="w-4 h-4 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
              />
            </svg>
            Logout
          </Button>
        )}
      </div>
    </header>
  )
}
